export enum WaveShapeEnum {
  REGULAR = 'regular',
  DEEP = 'deep',
  FLAT = 'flat',
  CONVEX = 'convex',
  CONCAVE = 'concave',
  WAVY = 'wavy',
}

export const getWaveShapeValues = () => Object.values(WaveShapeEnum) as [string, ...string[]];
